module.exports = __webpack_public_path__ + "img/banner1_460.3da1f99d.png";